import { TAGButton } from '@aspendental/shared-components-web';
import { Box, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { resendLinkButton, tipsWrapper, title } from './LoginWithEmailResendLink.styles';
type LoginWithEmailResendLinkProps = {
  toggleTipsDialog: () => void;
  email: string;
  handleOnSubmit: (payload: FieldValues) => void;
  expiredPage?: boolean;
};
const LoginWithEmailResendLink: FC<LoginWithEmailResendLinkProps> = ({
  expiredPage = false,
  handleOnSubmit,
  email,
  toggleTipsDialog
}) => {
  const [disabledButton, setDisabledButton] = useState(true);
  const handleDisableButtonTimeout = () => {
    setTimeout(() => {
      setDisabledButton(false);
    }, 6000);
  };
  const resendEmail = async () => {
    setDisabledButton(true);
    try {
      handleOnSubmit({
        email
      });
      handleDisableButtonTimeout();
    } catch {
      setDisabledButton(false);
    }
  };
  useEffect(() => {
    handleDisableButtonTimeout();
  }, []);
  return <>
			<Typography sx={title} variant={expiredPage ? 'heroMedium' : 'header2'} data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailResendLink.tsx">
				We emailed you a link
			</Typography>
			<Box sx={tipsWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailResendLink.tsx">
				<Typography data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailResendLink.tsx">Didn&apos;t get the link?</Typography>
				<Box data-sentry-element="Box" data-sentry-source-file="LoginWithEmailResendLink.tsx">
					<TAGButton variant="tertiaryDefault" onClick={toggleTipsDialog} data-sentry-element="TAGButton" data-sentry-source-file="LoginWithEmailResendLink.tsx">
						Try these tips
					</TAGButton>
				</Box>
			</Box>
			<TAGButton disabled={disabledButton} onClick={resendEmail} sx={resendLinkButton} variant="primaryDefault" data-sentry-element="TAGButton" data-sentry-source-file="LoginWithEmailResendLink.tsx">
				Resend Link
			</TAGButton>
		</>;
};
export default LoginWithEmailResendLink;